import type { SessionDataType } from '@confluence/session-data';

const ENV_TO_IDENTITY_ENV: Record<SessionDataType['environment'], 'dev' | 'staging' | 'prod'> = {
	STAGING: 'staging',
	DEVELOPMENT: 'dev',
	PRODUCTION: 'prod',
};

export const getIdentityEnv = (env: SessionDataType['environment']) =>
	ENV_TO_IDENTITY_ENV[env] || 'prod';
